// Token storage utilities for Devise JWT.
// Uses the storageAdapter abstraction so React Native can swap in AsyncStorage.
import { storage } from './storageAdapter';

const TOKEN_STORAGE_KEY = 'devise_jwt_token';

export const tokenStorage = {
  // Get access token (persists across tabs/sessions)
  getAccessToken(): string | null {
    return storage.getItem(TOKEN_STORAGE_KEY);
  },

  // Set access token
  setAccessToken(token: string): void {
    storage.setItem(TOKEN_STORAGE_KEY, token);
  },

  // Clear all tokens
  clearTokens(): void {
    storage.removeItem(TOKEN_STORAGE_KEY);
  },

  // Check if tokens exist
  hasTokens(): boolean {
    return !!this.getAccessToken();
  },

  // Returns true if the stored JWT has passed its exp claim.
  // Uses client-side decoding only — no signature verification.
  isAccessTokenExpired(): boolean {
    const token = this.getAccessToken();
    if (!token) return true;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return typeof payload.exp === 'number' && payload.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  },
};

export default tokenStorage;
